/* global __DEV__ */
import VersionUpdateModal from "@common/components/modal/VersionUpdateModal"
import { apiRequest } from "@data/redux/actions/api"
import { staticDataService } from "@data/services/staticDataService"
import { versionCompare } from "@data/utility/Utils"
import Constants from "expo-constants"
import React, { useEffect } from "react"
import { connect } from "react-redux"

/**
 * Forced-update gate. The blocking "update required" modal used to live inline
 * in BottomTabsNavigator only, so parent-mode users (rendered by the
 * mutually-exclusive ParentMainLayout) were never forced to update. Mounting
 * this self-contained guard in each authenticated layout fixes that; only one
 * layout renders at a time, so the modal never duplicates.
 *
 * We refetch static-data on mount (ParentMainLayout never fetches it otherwise)
 * then read min_client_version from the store. Fetch errors fall through to the
 * global axios interceptor, like every other static-data call.
 */
const ForceUpdateGuard = (props) => {
    useEffect(() => {
        props.apiRequest(staticDataService.getStaticData)
    }, [])

    if (__DEV__ || props.minimumVersion == null) return null

    const needsUpdate =
        versionCompare(props.minimumVersion, Constants.expoConfig?.version) ===
        1

    return needsUpdate ? <VersionUpdateModal /> : null
}

const mapStateToProps = (state) => ({
    minimumVersion: state.data.staticData?.min_client_version,
})

const mapDispatchToProps = {
    apiRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(ForceUpdateGuard)
